import React from "react";

/**
 * FilterToggleButton
 * Stylized toggle button with active/inactive states.
 */
const FilterToggleButton = ({ active, onClick, icon, title, colorClass = "bg-slate-900" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`w-9 h-9 cursor-pointer rounded-md transition-all flex items-center justify-center border ${active ? `${colorClass} text-white border-transparent shadow-md scale-105` : "bg-white border-slate-200 text-slate-500 hover:bg-slate-50 shadow-sm"}`}
    title={title}
  >
    {icon}
  </button>
);

export default FilterToggleButton;
